"use client";
// @ts-strict-ignore
import styled from "styled-components";

export const ContentBox = styled.div`
  margin: 0px;
  width: 100%;
  margin: 0px 0px 40px 0px;
  ${({ theme: { media } }) => media.mobileLandscape`
  margin: 0px 0px 52px 0px;
 `};
`;
export const Box = styled.div`
  margin: 0px 0px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colorPalette.gray[100]};
  padding: 14px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    max-width: 144px;
    height: auto;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colorPalette.gray[200]};
  }
`;
export const CopyContainer = styled.div`
  width: 100%;
  padding: 0px 0px 0px 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
